import React from 'react';
import { GiExitDoor } from "react-icons/gi"
import { AiFillHome, AiFillWechat } from "react-icons/ai"
import styled from 'styled-components';
import { ButtonContainer } from '../styled/Button';
import useChatActions from '../hooks/useChatActions';
import { useChat } from '../context/ChatProvider';

const Nav = styled.nav`
    display: none; /* Hide by default on larger screens */

    @media (max-width: 820px) {
        display: flex; /* Show on mobile devices */
        width: 100%;
        height: 7%;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
        background: #3f4e55;
        padding: 10px;
    }

    & div {
        justify-content: center;
        width: 100%;
    }
`;

const Navigation = ({ openRoomNav }) => {
    const { leaveRoom } = useChatActions();
    const { currentRoom, setCurrentRoom } = useChat();

    const leaveClickHandler = () => {
        setCurrentRoom(null);
        leaveRoom(currentRoom.id);
    }

    return (
        <Nav>
            <ButtonContainer device='mobile' onClick={ openRoomNav }>
                <a href='#'>
                    <AiFillWechat size='100%' />
                </a>
            </ButtonContainer>
    

        </Nav>
    );
};

export default Navigation;